export const RESET_PERKS_AND_SERVICES = 'RESET_PERKS_AND_SERVICES';
export const FETCH_PERKS_ADDONS_DATA = 'FETCH_PERKS_ADDONS_DATA';
export const FETCH_PERKS_ADDONS_DATA_SUCCESS = 'FETCH_PERKS_ADDONS_DATA_SUCCESS';
export const FETCH_PERKS_ADDONS_DATA_FAILURE = 'FETCH_PERKS_ADDONS_DATA_FAILURE';
export const RESET_PREFETCH_FLAG = 'RESET_PREFETCH_FLAG';

// Cart add/remove for service offers (YouTube TV, Whole Home Wi-Fi)
export const ADD_OR_REMOVE_FEATURE_TO_CART = 'ADD_OR_REMOVE_FEATURE_TO_CART';

export const GET_CART_DETAILS_FROM_API = 'GET_CART_DETAILS_FROM_API';

export const SET_STICKY_FOOTER_HEIGHT = 'SET_STICKY_FOOTER_HEIGHT';

export const SET_WHW_BASIC_AEM = 'PERKS_SET_WHW_BASIC_AEM';


export const UPDATE_PROCESS_STEP = 'PERKS_UPDATE_PROCESS_STEP';
